import { currentWeather } from './weatherApi';

export const api = {
  currentWeather,
};
